import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=25fb3d76&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25fb3d76')) {
      api.createRecord('25fb3d76', component.options)
    } else {
      api.reload('25fb3d76', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=25fb3d76&", function () {
      api.rerender('25fb3d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/checkbox.vue"
export default component.exports